import React, { useState } from 'react';
import Footer from '../../../components/Footer';
import VegIcon from '../../../components/VegIcon';
import OffersRenderer from '../../../components/OffersRenderer';
import './NeonNectar.css';

import DEFAULT_LOGO from '../../../assets/defaults/logo-default.jpg';
import DEFAULT_ITEM from '../../../assets/defaults/item-default.jpg';

const NeonNectar = ({ data }) => {
    const restaurant = data?.restaurant || {};
    const menus = data?.menus || [];
    const [activeMenuId, setActiveMenuId] = useState(menus[0]?.id);
    const [selectedItem, setSelectedItem] = useState(null);

    const activeMenu = menus.find(m => m.id === activeMenuId) || menus[0];

    if (!data) return <div className="neon-loading">Powering up the grid...</div>;

    return (
        <div className="neon-root">
            <div className="neon-bg-glow"></div>
            <header className="neon-header">
                <div className="neon-logo-container">
                    <img src={restaurant.logoUrl || DEFAULT_LOGO} alt="logo" className="neon-logo" />
                </div>
                <h1 className="neon-title" title={restaurant.name}>{restaurant.name || 'Neon Diner'}</h1>
                <p className="neon-subtitle" title={restaurant.description}>{restaurant.description || 'Synthwave Sips & Digital Bites'}</p>

                <div className="neon-contact">
                    {restaurant.address && <span className="neon-contact-item">📍 {restaurant.address}</span>}
                    {restaurant.phoneNumber && <span className="neon-contact-item">📞 {restaurant.phoneNumber}</span>}
                </div>
            </header>

            {/* Offers / Notes */}
            <OffersRenderer offers={data?.offers} />

            {menus.length > 1 && (
                <nav className="neon-nav">
                    {menus.map(menu => (
                        <button
                            key={menu.id}
                            className={`neon-nav-btn ${activeMenuId === menu.id ? 'active' : ''}`}
                            onClick={() => setActiveMenuId(menu.id)}
                        >
                            {menu.name}
                        </button>
                    ))}
                </nav>
            )}

            <main className="neon-main">
                {activeMenu ? (
                    <div className="neon-menu-area">
                        {activeMenu.categories?.sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0)).map(cat => (
                            <section key={cat.id} className="neon-section">
                                <h2 className="neon-cat-title">{cat.name}</h2>
                                <div className="neon-grid">
                                    {cat.items?.map(item => (
                                        <NeonItem key={item.id} item={item} onClick={() => setSelectedItem(item)} />
                                    ))}
                                </div>
                            </section>
                        ))}
                    </div>
                ) : (
                    <div className="neon-empty">The grid is silent. No items found.</div>
                )}
            </main>

            {selectedItem && (
                <div className="neon-modal-overlay" onClick={() => setSelectedItem(null)}>
                    <div className="neon-modal" onClick={e => e.stopPropagation()}>
                        <button className="neon-modal-close" onClick={() => setSelectedItem(null)}>✕</button>
                        <div className="neon-modal-img">
                            <img src={selectedItem.imageUrl || DEFAULT_ITEM} alt={selectedItem.name} />
                        </div>
                        <div className="neon-modal-body">
                            <h3>{selectedItem.name}</h3>
                            <p className="neon-modal-price">₹{(selectedItem.price || 0).toLocaleString()}</p>
                            <p className="neon-modal-desc">{selectedItem.description}</p>

                            <div className="neon-modal-variants">
                                <h4>Grid Enhancements</h4>
                                {selectedItem.variants?.filter(v => v.isActive).map(v => (
                                    <div key={v.id} className="neon-v-row">
                                        <span>{v.name}</span>
                                        <span className="neon-v-price">
                                            {v.price > 0 ? `₹${v.price.toLocaleString()}` : 'Included'}
                                        </span>
                                    </div>
                                ))}
                                {(!selectedItem.variants || selectedItem.variants.filter(v => v.isActive).length === 0) && (
                                    <p className="no-variants">Standard optimization. No modifications.</p>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <Footer />
        </div>
    );
};

const NeonItem = ({ item, onClick }) => {
    if (!item) return null;

    return (
        <div className={`neon-card ${!item.isAvailable ? 'unavailable' : ''}`} onClick={onClick} style={{ cursor: 'pointer' }}>
            <div className="neon-card-inner">
                <div className="neon-item-img-container">
                    <img src={item.imageUrl || DEFAULT_ITEM} alt={item.name} className="neon-item-img" />
                    <div className="neon-price-pill">₹{(item.price || 0).toLocaleString()}</div>
                    {(item.isVeg !== undefined && item.isVeg !== null) && (
                        <span className={`neon-veg-badge ${item.isVeg ? 'veg' : 'nonveg'}`}>
                            <span className="neon-veg-dot"></span>
                        </span>
                    )}
                </div>

                <div className="neon-card-body">
                    <h3 className="neon-item-name" title={item.name}>{item.name}</h3>
                    <p className="neon-item-desc" title={item.description}>{item.description}</p>

                    {item.tags && item.tags.length > 0 && (
                        <div className="neon-tags">
                            {item.tags.map(tag => (
                                <span key={tag} className="neon-tag">{tag}</span>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default NeonNectar;
